"use client";

import { BotpressScripts } from "./botpress-scripts";
import { BigButtonTrigger, CTAButtonTrigger, FABTrigger, MoreMenuTrigger } from "./chat-triggers";
import { useBotpressWebchat } from "./use-botpress-webchat";

export interface BotpressChatProps {
	/**
	 * Display mode for the chatbot
	 * - 'fab': Floating action button (default)
	 * - 'cta-button': Button for CTA bar
	 * - 'big-button': Large dedicated button for contact page
	 * - 'more-menu': Menu item format
	 * - 'custom': Custom button triggering the chat
	 */
	mode?: "fab" | "cta-button" | "big-button" | "more-menu" | "custom";
	className?: string;
	children?: React.ReactNode;
	onToggle?: (isOpen: boolean) => void;
}

/**
 * Botpress Chat component with multiple display modes
 * Uses the Botpress embed scripts for webchat integration
 */
export function BotpressChat({ mode = "fab", className = "", children, onToggle }: BotpressChatProps) {
	const { isOpen } = useBotpressWebchat();

	// Render the trigger button based on mode
	const renderTrigger = () => {
		switch (mode) {
			case "fab":
				return <FABTrigger isOpen={isOpen} className={className} />;
			case "cta-button":
				return <CTAButtonTrigger />;
			case "more-menu":
				return <MoreMenuTrigger />;
			case "big-button":
				return <BigButtonTrigger className={className} />;
			case "custom":
				return (
					<button
						type="button"
						onClick={() => {
							// toggle(); toggle happens via ID
							onToggle?.(!isOpen);
						}}
						id="bp-toggle-chat"
						className={className}
					>
						{children}
					</button>
				);
			default:
				return null;
		}
	};

	return (
		<>
			{renderTrigger()}
			<BotpressScripts />
		</>
	);
}
